import { gql } from '@apollo/client';
import { PLATFORM_MERCHANT_CONTRACT_FIELDS, PLATFORM_PRODUCER_CONTRACT_FIELDS } from './contract';

export const REQUEST_PARTICIPANT_FIELDS = gql`
  fragment RequestParticipantFields on RequestParticipant {
    partyId
    userId
  }
`;

export const ACTIVITY_APPROVAL_FIELDS = gql`
  fragment ActivityApprovalFields on ActivityApproval {
    accepted
    note
  }
`;

export const REQUEST_PARTICIPANT_ACTIVITY_FIELDS = gql`
  ${REQUEST_PARTICIPANT_FIELDS}
  ${ACTIVITY_APPROVAL_FIELDS}
  fragment RequestParticipantActivityFields on RequestParticipantActivity {
    id
    participant {
      ...RequestParticipantFields
    }
    approval {
      ...ActivityApprovalFields
    }
  }
`;

export const REQUEST_PLATFORM_MERCHANT_CONTRACT_CHANGE_FIELDS = gql`
  ${REQUEST_PARTICIPANT_FIELDS}
  ${PLATFORM_MERCHANT_CONTRACT_FIELDS}
  fragment RequestPlatformMerchantContractChangeFields on RequestPlatformMerchantContractChange {
    requester {
      ...RequestParticipantFields
    }
    approver {
      ...RequestParticipantFields
    }
    previousContract {
      ...PlatformMerchantContractFields
    }
    nextContract {
      ...PlatformMerchantContractFields
    }
  }
`;

export const REQUEST_PLATFORM_PRODUCER_CONTRACT_CHANGE_FIELDS = gql`
  ${REQUEST_PARTICIPANT_FIELDS}
  ${PLATFORM_PRODUCER_CONTRACT_FIELDS}
  fragment RequestPlatformProducerContractChangeFields on RequestPlatformProducerContractChange {
    requester {
      ...RequestParticipantFields
    }
    approver {
      ...RequestParticipantFields
    }
    previousContract {
      ...PlatformProducerContractFields
    }
    nextContract {
      ...PlatformProducerContractFields
    }
  }
`;

export const REQUEST_CONTENT_FIELDS = gql`
  ${REQUEST_PLATFORM_MERCHANT_CONTRACT_CHANGE_FIELDS}
  ${REQUEST_PLATFORM_PRODUCER_CONTRACT_CHANGE_FIELDS}
  fragment RequestContentFields on RequestContent {
    platformMerchantContractChange {
      ...RequestPlatformMerchantContractChangeFields
    }
    platformProducerContractChange {
      ...RequestPlatformProducerContractChangeFields
    }
  }
`;

export const REQUEST_FIELDS = gql`
  ${REQUEST_PARTICIPANT_ACTIVITY_FIELDS}
  ${REQUEST_CONTENT_FIELDS}
  fragment RequestFields on Request {
    id
    type
    participantPartyIds
    request {
      ...RequestContentFields
    }
    activities {
      ...RequestParticipantActivityFields
    }
    createdAt
    validUntil
    updatedAt
    finishedAt
  }
`;
